exports.UPLOAD_FILE_SUCCESS = "upload-file-success";
exports.UPLOAD_FILE_ERROR = "upload-file-error";
exports.UPLOAD_FILE_DENIED = "upload-file-denied";
exports.UPLOAD_RECAPTCHA_FAILED = "upload-recaptcha-failed";
